import { useEffect, useState } from "react";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";

import React from "react";

import CreatableSelect from "react-select/creatable";

interface Option {
  readonly label: string;
  readonly value: string;
}

const createOption = (label: string) => ({
  label,
  value: label.toLowerCase().replace(/\W/g, ""),
});

interface CountedAutoCompleteProps {
  id: string;
  label: string;
  onChange: (value: any) => void;
  placeholder?: string;
  maxLength: number;
  minLength: number;
  required?: boolean;
  inputClass?: string;
  type?: string;
  error?: string;
  name?: string;
  defaultValue: string;
  helpText?: string;
  description?: string;
  disabled: boolean;
  setErrorSubmission: (value: boolean) => void;
  options: Array<string>;
}
const CountedAutoComplete: React.FC<CountedAutoCompleteProps> = ({
  id,
  label,
  onChange,
  placeholder,
  maxLength = 100,
  minLength,
  required,
  inputClass,
  type,
  error,
  name,
  defaultValue,
  helpText,
  description,
  disabled,
  setErrorSubmission,
  options,
}) => {
  const [input, setInput] = useState<string>(defaultValue ?? "");
  const [err, setErr] = useState<string>("");
  const [labelledOptions, setLabelledOptions] = useState<Option[]>();
  const [value, setValue] = useState<Option | null>();

  useEffect(() => {
    let optionsArray = options.map((i: string) => {
      return createOption(i);
    });
    setLabelledOptions(optionsArray);
  }, [options]);

  useEffect(() => {
    setInput(defaultValue);
  }, [defaultValue]);
  const warningError = "You are close exceeding the word limit";

  const handleChange = (text: any) => {
    setInput(text?.value);

    if (text?.value.length >= maxLength) {
      setErr(`Maximum ${maxLength} characters allowed`);
    } else if (text?.value.length < minLength) {
      setErr(`Minimum ${minLength} characters are needed`);
    } else setErr("");

    handleErr();

    onChange({
      target: {
        value: text?.value,
      },
    });
  };

  const handleCreate = (inputValue: any) => {
    setValue(createOption(inputValue));
    setInput(inputValue);
    onChange({
      target: {
        value: inputValue,
      },
    });
  };
  const handleErr = () => {
    if (err.length > 0) {
      setErrorSubmission(true);
    } else setErrorSubmission(false);
  };
  return (
    <div>
      <div className="my-6 w-auto">
        <div className="flex justify-initial">
          <label htmlFor={id} className="block text-sm text-tootler-grey-600">
            {label} <span className="text-red-400"> {required && "*"} </span>
          </label>
          <div className="pl-2"></div>
        </div>
        <p className="font-light text-sm text-gray-500 ">{description}</p>

        <CreatableSelect
          isClearable
          onChange={(newValue) => handleChange(newValue)}
          options={labelledOptions}
          value={value}
          placeholder="Select an option "
          styles={{
            control: (base, { isFocused }) => ({
              ...base,
              border: isFocused ? "2px solid #3F5CEB" : "1px solid #ccc",
              borderRadius: "4px",
              color: "#111827",
              backgroundColor: "#E5E7EB",
              boxShadow: isFocused ? "none" : "0 0 0 1px #ccc",

              ":hover": {
                backgroundColor: "#E7F3FD",
              },
            }),

            option: (base, { isSelected }) => ({
              ...base,
              backgroundColor: isSelected ? "#D9ECFC" : "#E5E7EB",
              color: "#333",
              ":hover": {
                backgroundColor: "#E7F3FD",
              },
            }),
          }}
          onCreateOption={(inputValue) => handleCreate(inputValue)}
        />
        <p className="mt-2 text-xs text-gray-600" id={id}>
          {helpText}
        </p>
        {error && (
          <p className=" text-sm text-red-600" id={id}>
            {error}
          </p>
        )}
        {err && (
          <div className="flex space-x-2 items-center">
            <ExclamationCircleIcon
              className={`h-5 w-5 text-semantic-error  ${
                err == warningError ? "hidden" : "flex"
              }`}
            />
            <p
              className={` text-sm ${
                err == warningError
                  ? "text-semantic-warning"
                  : "text-semantic-error"
              }`}
              id={id}
            >
              {err}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CountedAutoComplete;
